webpackJsonp([218],{

/***/ 1332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewbieMissionCfg_vue__ = __webpack_require__(3106);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143c5e59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewbieMissionCfg_vue__ = __webpack_require__(5850);
function injectStyle (ssrContext) {
  __webpack_require__(5848)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143c5e59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewbieMissionCfg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143c5e59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewbieMissionCfg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchMasRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return freezeFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newUserConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newbieMissionConfigRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  call_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通类型', 'integer'))],
  communicate_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择记录详情', 'integer'))],
  record_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通详情', 'string'))],
  communicate_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通方式', 'integer'))]

};

var searchMasRules = {
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择群发消息', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息标题', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到30个字符'), { min: 1, max: 30 })],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息内容', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到300个字符'), { min: 1, max: 300 })]
};

var formRules = {
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入手机号', 'string'))]
};

var freezeFormRules = {
  freeze_status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号状态', 'integer'))],
  freeze_reason: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号原因', 'integer'))],
  freeze_reason_desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入封号原因'))]

};

var newUserConfigRules = {
  condition_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择条件类型', 'string'))]
};

var newbieMissionConfigRules = {
  'watch_tutorial_video.video_url': [{ required: true, message: '请选择教程视频', trigger: 'change' }],
  'watch_tutorial_video.img_url': [{ required: true, message: '请上传教程视频封面', trigger: 'change' }],
  'finish_newbie_task.task_id': [{ required: true, message: '请选择一个新手任务', trigger: 'change' }]
};

/***/ }),

/***/ 3106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_rules__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_api_js__ = __webpack_require__(258);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false,
      newbieMissionConfigRules: __WEBPACK_IMPORTED_MODULE_5__users_rules__["d" /* newbieMissionConfigRules */],
      form: {
        is_show_mission_dialog: true,
        is_newbie_mission_enable: true,
        watch_tutorial_video: {
          video_url: '',
          img_url: ''
        },
        finish_newbie_task: {
          task_id: '',
          task_title: '',
          salary: ''
        }
      },
      videoFileList: [],
      imgFileList: [],
      taskCache: {}
    };
  },

  computed: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, request.map(['getTaskDetail']), {
    onLoad: function onLoad() {
      this.getConfig();
    },
    onTaskChange: function onTaskChange() {
      this.form.finish_newbie_task.task_title = '';
      this.form.finish_newbie_task.salary = '';

      var taskId = this.form.finish_newbie_task.task_id;
      if (this.taskCache[taskId]) {
        this.form.finish_newbie_task.task_title = this.taskCache[taskId].task_title;
        this.form.finish_newbie_task.salary = this.taskCache[taskId].salary;
      }
    },
    queryTaskTableWithCache: function queryTaskTableWithCache(params) {
      var _this = this;

      return request.common('queryTaskTable', params).then(function (res) {
        res.data.data.forEach(function (item) {
          _this.taskCache[item.taskid] = {
            task_id: item.taskid + '',
            task_title: item.title,
            salary: item.salary + ''
          };
        });
        return res;
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      var initLoading = this.$loading({ text: '配置拉取中...', lock: true });
      request.common('getNewbieMissionCfgApi', {}).then(function (_ref) {
        var data = _ref.data;

        if (data && data.value && !_.isEmpty(data.value)) {
          var config = data.value;
          var missionCfg = _.get(config, 'newbie_mission_config', {});
          var tutorialVideo = missionCfg.watch_tutorial_video || {};
          var newbieTask = missionCfg.finish_newbie_task || {};

          _this2.form.is_show_mission_dialog = _.get(config, 'is_show_mission_dialog', false);
          _this2.form.is_newbie_mission_enable = _.get(config, 'is_newbie_mission_enable', true);
          _this2.form.watch_tutorial_video = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this2.form.watch_tutorial_video, tutorialVideo);
          _this2.form.finish_newbie_task = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this2.form.finish_newbie_task, newbieTask);

          // 把当前回流的任务数据压入缓存池作为安全种子，防止被 remote-select 初始回显误清空
          if (newbieTask.task_id) {
            _this2.taskCache[newbieTask.task_id] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, newbieTask);
          }
        }
      }).catch(function () {
        _this2.$message.error('配置拉取失败，请刷新页面重试');
      }).finally(function () {
        initLoading.close();
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (!filter.hasPermission(20002)) {
        this.$alert('您没有保存 新手任务配置 的权限');
        return;
      }

      this.$refs.missionForm.validate(function (valid, invalidFields) {
        if (valid) {
          _this3.saveConfig();
        } else {
          var messages = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(invalidFields || {}).map(function (errors) {
            return errors.map(function (e) {
              return e.message;
            }).join('；');
          }).join('；');
          _this3.$message.error('表单填写不正确：' + messages);
        }
      });
    },
    saveConfig: function saveConfig() {
      var _this4 = this;

      var params = {
        is_show_mission_dialog: this.form.is_show_mission_dialog,
        is_newbie_mission_enable: this.form.is_newbie_mission_enable,
        newbie_mission_config: {
          watch_tutorial_video: this.form.watch_tutorial_video,
          finish_newbie_task: this.form.finish_newbie_task
        }
      };
      this.isSaving = true;
      request.common('setNewbieMissionCfgApi', params).then(function () {
        _this4.$alert('配置保存成功');
      }).catch(function () {
        _this4.$message.error('配置保存失败');
      }).finally(function () {
        _this4.isSaving = false;
      });
    },
    handleVideoUpload: function handleVideoUpload(options) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, fileType, fileSizeMB, isVideo, uploadLoading, videoUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = options.file;
                fileType = file.type;
                fileSizeMB = file.size / 1024 / 1024;
                isVideo = fileType === 'video/mp4';

                if (isVideo) {
                  _context.next = 7;
                  break;
                }

                _this5.$message.error('只能上传MP4视频文件!');
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('只能上传MP4视频文件!')));

              case 7:
                if (!(fileSizeMB > 200)) {
                  _context.next = 10;
                  break;
                }

                _this5.$message.error('视频大小不能超过200MB!');
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('视频大小不能超过200MB!')));

              case 10:
                uploadLoading = _this5.$loading({
                  lock: true,
                  text: '文件上传中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context.prev = 11;
                _context.next = 14;
                return _this5.doAdminDirectUploadFile(file);

              case 14:
                videoUrl = _context.sent;

                if (videoUrl) {
                  _this5.form.watch_tutorial_video.video_url = videoUrl;
                  _this5.videoFileList = [{ name: file.name, url: videoUrl }];
                  _this5.$message.success('视频上传成功');
                }
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](11);

                _this5.$message.error('视频上传失败: ' + _context.t0.message);
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 22:
                _context.prev = 22;

                uploadLoading.close();
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[11, 18, 22, 25]]);
      }))();
    },
    doAdminDirectUploadFile: function doAdminDirectUploadFile(file) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, res, uploadUrl, contentType, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {
                  file_name: file.name,
                  ext: file.name.split('.').pop().toLowerCase(),
                  content_type: file.type
                };
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__users_api_js__["adminDirectUploadFilesApi"])(params);

              case 4:
                res = _context2.sent;

                if (!(res.data.ret === 0)) {
                  _context2.next = 16;
                  break;
                }

                uploadUrl = res.data.detail.signedUrl;
                contentType = res.data.detail.content_type;
                _context2.next = 10;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: file
                });

              case 10:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 13;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25\uFF0C\u539F\u56E0: ' + uploadRes.status);

              case 13:
                return _context2.abrupt('return', res.data.detail.url);

              case 16:
                throw new Error(res.data.msg || '上传失败');

              case 17:
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](0);
                throw new Error(_context2.t0.message || '上传失败');

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 19]]);
      }))();
    },
    handleVideoRemove: function handleVideoRemove() {
      this.form.watch_tutorial_video.video_url = '';
      this.videoFileList = [];
    },
    handleImageUpload: function handleImageUpload(options) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var file, fileType, fileSizeMB, isImage, uploadLoading, imgUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                file = options.file;
                fileType = file.type;
                fileSizeMB = file.size / 1024 / 1024;
                isImage = fileType.startsWith('image/');

                if (isImage) {
                  _context3.next = 7;
                  break;
                }

                _this7.$message.error('只能上传图片文件!');
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('只能上传图片文件!')));

              case 7:
                if (!(fileSizeMB > 10)) {
                  _context3.next = 10;
                  break;
                }

                _this7.$message.error('图片大小不能超过10MB!');
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('图片大小不能超过10MB!')));

              case 10:
                uploadLoading = _this7.$loading({
                  lock: true,
                  text: '文件上传中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context3.prev = 11;
                _context3.next = 14;
                return _this7.doAdminDirectUploadFile(file);

              case 14:
                imgUrl = _context3.sent;

                if (imgUrl) {
                  _this7.form.watch_tutorial_video.img_url = imgUrl;
                  _this7.imgFileList = [{ name: file.name, url: imgUrl }];
                  _this7.$message.success('封面上传成功');
                }
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](11);

                _this7.$message.error('封面上传失败: ' + _context3.t0.message);
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context3.t0));

              case 22:
                _context3.prev = 22;

                uploadLoading.close();
                return _context3.finish(22);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[11, 18, 22, 25]]);
      }))();
    },
    handleImageRemove: function handleImageRemove() {
      this.form.watch_tutorial_video.img_url = '';
      this.imgFileList = [];
    }
  })
});

/***/ }),

/***/ 5848:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5849);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3f980162", content, true, {});

/***/ }),

/***/ 5849:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".config-container[data-v-143c5e59]{padding:10px 20px}.config-container .config-form[data-v-143c5e59]{max-width:800px}.config-container .video-preview[data-v-143c5e59]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.config-container .video-preview video[data-v-143c5e59]{border:1px solid #dcdfe6;border-radius:4px;background-color:#f5f7fa}.config-container .img-preview[data-v-143c5e59]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.config-container .img-preview img[data-v-143c5e59]{border:1px solid #dcdfe6;border-radius:4px;background-color:#f5f7fa}", "", {"version":3,"sources":["/workspace/src/views/users/pages/NewbieMissionCfg.vue"],"names":[],"mappings":"AACA,mCAAmC,iBAAiB,CACnD,AACD,gDAAgD,eAAe,CAC9D,AACD,kDAAkD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CACzK,AACD,wDAAwD,yBAAyB,kBAAkB,wBAAwB,CAC1H,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CACvK,AACD,oDAAoD,yBAAyB,kBAAkB,wBAAwB,CACtH","file":"NewbieMissionCfg.vue","sourcesContent":["\n.config-container[data-v-143c5e59]{padding:10px 20px\n}\n.config-container .config-form[data-v-143c5e59]{max-width:800px\n}\n.config-container .video-preview[data-v-143c5e59]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start\n}\n.config-container .video-preview video[data-v-143c5e59]{border:1px solid #DCDFE6;border-radius:4px;background-color:#F5F7FA\n}\n.config-container .img-preview[data-v-143c5e59]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start\n}\n.config-container .img-preview img[data-v-143c5e59]{border:1px solid #DCDFE6;border-radius:4px;background-color:#F5F7FA\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('div',{staticClass:"config-container"},[_c('div',{staticClass:"config-form"},[_c('el-form',{ref:"missionForm",attrs:{"model":_vm.form,"rules":_vm.newbieMissionConfigRules,"size":"small","label-width":"160px"}},[_c('el-form-item',{attrs:{"label":"启用状态","prop":"is_newbie_mission_enable"}},[_c('el-switch',{attrs:{"active-text":"启用","inactive-text":"停用"},model:{value:(_vm.form.is_newbie_mission_enable),callback:function ($$v) {_vm.$set(_vm.form, "is_newbie_mission_enable", $$v)},expression:"form.is_newbie_mission_enable"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("关闭后，后续注册的用户不再展示新手引导弹窗，弹出过的用户会继续走完流程")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"总开关","prop":"is_show_mission_dialog"}},[_c('el-switch',{attrs:{"active-text":"启用","inactive-text":"停用"},model:{value:(_vm.form.is_show_mission_dialog),callback:function ($$v) {_vm.$set(_vm.form, "is_show_mission_dialog", $$v)},expression:"form.is_show_mission_dialog"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("关闭后，线上所有用户都不展示新手引导弹窗，包括正在进行中的用户")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"新手教程视频","prop":"watch_tutorial_video.video_url"}},[(_vm.form.watch_tutorial_video.video_url)?_c('div',{staticClass:"video-preview"},[_c('video',{attrs:{"src":_vm.form.watch_tutorial_video.video_url,"controls":"","width":"400","height":"225"}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":_vm.handleVideoRemove}},[_vm._v("删除视频重新上传\n              ")])],1):_c('el-upload',{staticClass:"upload-demo",attrs:{"http-request":_vm.handleVideoUpload,"file-list":_vm.videoFileList,"accept":".mp4","limit":1,"action":"#"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n              ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传MP4视频文件，且不超过200MB\n              ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"新手教程视频封面","prop":"watch_tutorial_video.img_url"}},[(_vm.form.watch_tutorial_video.img_url)?_c('div',{staticClass:"img-preview"},[_c('img',{attrs:{"src":_vm.form.watch_tutorial_video.img_url,"width":"400","alt":"视频封面"}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":_vm.handleImageRemove}},[_vm._v("删除封面重新上传\n              ")])],1):_c('el-upload',{staticClass:"upload-demo",attrs:{"http-request":_vm.handleImageUpload,"file-list":_vm.imgFileList,"accept":"image/*","limit":1,"action":"#"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n              ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传图片文件，建议尺寸与视频比例一致\n              ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"选择新手任务","prop":"finish_newbie_task.task_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"taskid","label-key":"title","value-key":"taskid","placeholder":"输入任务名称搜索","findParams":{id: _vm.form.finish_newbie_task.task_id},"query-request":_vm.queryTaskTableWithCache,"find-request":_vm.getTaskDetail},on:{"change":_vm.onTaskChange},model:{value:(_vm.form.finish_newbie_task.task_id),callback:function ($$v) {_vm.$set(_vm.form.finish_newbie_task, "task_id", $$v)},expression:"form.finish_newbie_task.task_id"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.isSaving},on:{"click":_vm.onSubmit}},[_vm._v("保存配置\n            ")])],1)],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/newbie-mission-cfg.e856690b51207fbc13cb.js